<!-- Hero Section -->
<section id="home" class="py-12 lg:py-16 bg-gradient-to-b from-[#fcfbf9] to-[#f4efe4]">
  <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
    
    <!-- LEFT: Text Content (7 Columns) -->
    <div class="lg:col-span-6 space-y-6 my-24">
      
      

      <!-- Main Headline -->
      <div class="space-y-4">
        @if (!isLoading()) {
          <h1 class="text-4xl sm:text-5xl lg:text-6xl font-black text-[#0e3b2e] leading-[1.1] tracking-tight">
            Turning public data into <span class="text-[#e6b012]">accountable</span> progress.
          </h1>
        } @else {
          <div class="shimmer h-[3rem] w-[100%] rounded-lg mb-2"></div>
          <div class="shimmer h-[3rem] w-[80%] rounded-lg mb-2"></div>
        }

        <!-- Subtitle Description -->
        @if (!isLoading()) {
          <p class="text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl">
            The National M&amp;E System unifies planning, tracking, and reporting across government entities. Drive data-informed policy and deliver measurable impact for Tanzania's Vision 2050.
          </p>
        } @else {
          <div class="shimmer h-[1.25rem] w-[95%] rounded-md mb-1"></div>
          <div class="shimmer h-[1.25rem] w-[80%] rounded-md mb-1"></div>
        }
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-4 pt-2">
        <a
          routerLink="/login"
          class="inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-[#0e3b2e] hover:bg-[#07231a] text-white font-bold text-sm tracking-wide transition-all cursor-pointer active:scale-95"
        >
          <span>Explore Platform</span>
          <mat-icon class="!text-[18px] !w-4.5 !h-4.5">arrow_forward</mat-icon>
        </a>

        <a
          routerLink="/projects"
          class="inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full text-[#0e3b2e] font-bold text-sm border border-[#0e3b2e]/20  transition-all cursor-pointer active:scale-95"
        >
          <span>View Public Reports</span>
        </a>
      </div>

      <!-- Flag Accent Stripe -->
      <div class="flex gap-2 pt-4">
        <span class="h-2 w-12 rounded-l-full bg-[#1EB53A]"></span>
        <span class="h-2 w-12 bg-[#FCD20E]"></span>
        <span class="h-2 w-12 bg-black"></span>
        <span class="h-2 w-12 bg-[#FCD20E]"></span>
        <span class="h-2 w-12 rounded-r-full bg-[#00A3DD]"></span>
      </div>

      <!-- Key Metrics Strip -->
      <div class="grid grid-cols-3 gap-6 pt-4 border-t border-[#0e3b2e]/10">
        @if (!isLoading()) {
          @for (stat of stats; track $index) {
            <div class="space-y-1">
              <p class="text-2xl lg:text-3xl font-black text-[#0e3b2e]">{{ stat.displayValue }}</p>
              <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">{{ stat.label | translate }}</p>
            </div>
          }
        } @else {
          @for (n of [1, 2, 3]; track $index) {
            <div class="space-y-1">
              <div class="shimmer h-8 w-16 rounded-md"></div>
              <div class="shimmer h-3 w-20 rounded-md"></div>
            </div>
          }
        }
      </div>

    </div>

    <!-- RIGHT: Preserved Media Sliding Carousel (6 Columns) -->
    <div class="lg:col-span-6 w-full">
      <div class="w-full flex gap-3 h-[460px] rounded-2xl p-2">
        @if (!isLoading()) {
          @for (media of medias; track media.title; let i = $index) {
            <div
              (click)="selectSlide(i)"
              class="relative flex-shrink-0 h-full rounded-xl overflow-hidden cursor-pointer transition-all duration-700 ease-in-out border border-white/20 shadow-md group"
              [ngClass]="i === activeIndex ? 'flex-1' : 'w-24 lg:w-28 opacity-80 hover:opacity-100'"
            >
              <!-- Background Sliding Image -->
              <img [src]="media.imagePath" [alt]="media.title" class="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />

              <!-- Overlay -->
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-opacity duration-500"
                [class.opacity-100]="i === activeIndex"
                [class.opacity-40]="i !== activeIndex"
              ></div>

              <!-- Active Slide Caption -->
              @if (i === activeIndex) {
                <div class="absolute bottom-0 left-0 right-0 p-6 flex flex-col justify-end gap-3 text-white">
                  
                  <h3 class="text-xl lg:text-2xl font-bold leading-tight drop-shadow-md">
                    {{ media.title }}
                  </h3>
                  <div class="flex items-center gap-2 pt-1">
                    <a
                      routerLink="/projects"
                      class="px- hover:bg-white/30  text-xs text-white transition-all inline-flex items-center gap-2"
                    >
                      <span>Explore Project</span>
                      <mat-icon class="!text-[16px] !w-4 !h-4">arrow_forward</mat-icon>
                    </a>
                  </div>
                </div>
              } @else {
                <!-- Vertical Rotated Label for Inactive Slides -->
                <div class="absolute inset-0 flex items-center justify-center p-3">
                  <span
                    class="text-xs font-bold tracking-wider text-white/90 whitespace-nowrap block"
                    style="writing-mode: vertical-rl; transform: rotate(180deg);"
                  >
                   
                  </span>
                </div>
              }
            </div>
          }
        } @else {
          <div class="w-full h-full rounded-xl shimmer"></div>
        }
      </div>
    </div>

  </div>
</section>
